import { Grid } from "@mui/material";
import Accordion from "components/Accordion";
import { FnBlock_UI } from "components/BlockUI";
import { BtnAdd, BtnDeleteTable, BtnViewTable } from "components/Button";
import TableUI from "components/TableUI";
import { ColumnProps } from "components/TableUI/TableUI";
import { List } from "linqts";
import { useContext, useEffect, useState } from "react";
import { AxiosPost, SendAPIFile } from "utilities/Axios";
import { FIleItem } from "view/Register/Component/RegisterClass";
import { RecruitmentContext } from "./Recruitment_From";
import { AlertMsg, AlertTitle } from "config/AlertMsgConfig";
import { SwAlert } from "components/Alert";

const AdminPuloadFile = () => {
    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const { objMasterData } = useContext(RecruitmentContext);
    const [lstFile, setlstFile] = useState([]);
    useEffect(() => {
        setlstFile(objMasterData?.lstCRegisterAdminFile || []);
    }, [objMasterData?.lstCRegisterAdminFile])
    const ColumnData: ColumnProps[] = [{
        id: "nNo",
        name: "ลำดับ",
        width: "5%",
    },
    {
        id: "sFileName",
        name: "ชื่อไฟล์",
        width: "60%",
        cellAlign: "left"
    },
    {
        id: "sAddDate",
        name: "วันที่อัปโหลด",
        width: "10%",
        cellAlign: "center"
    },
    {
        id: "sAddByName",
        name: "ผู้อัปโหลด",
        width: "15%",
        cellAlign: "left"
    },
    {
        id: "3",
        name: "",
        width: "10%",
        renderCell: (item) => {
            return (
                <div style={{ display: "inline-flex", textAlign: "center" }}>
                    <BtnViewTable onClick={() => {
                        const a = document.createElement('a');
                        a.href = item.sUrl;
                        a.target = "_blank";
                        a.download = item.sUrl.split('/').pop();
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }} />
                    {objMasterData.isEditData && <BtnDeleteTable style={{ marginLeft: "5px" }} onClick={() => { onDeleteFile(item) }} />}
                </div>
            )
        }
    }]

    const onUploadFile = () => {
        const onClickFile = document.getElementById("onAdminCameraFile");
        if (onClickFile) {
            onClickFile.click();
        }
    }
    const _SendAPIFile = async (_FileItem) => {
        let lstFile_ = _FileItem.target.files;
        await SendAPIFile(lstFile_[0], (res: FIleItem[]) => {
            console.log("res", res);
            if (res.length > 0 && res[0]) {
                let obj = {
                    nRegisterID: objMasterData?.objData?.objFormData?.nRegisterID,
                    cFIleItem: res[0]
                };
                AxiosPost("UserRecruitment/onUpLoadFileAdmin", obj, (res) => {
                    SwAlert.Success(AlertTitle.Success, AlertMsg.SaveComplete, () => {
                        setlstFile(res || []);
                    });
                }, null, null, null, () => {
                    UnBlockUI();
                })
            }
        }, (er) => {
            console.log("er", er);
        });

    }
    const onDeleteFile = (fileData) => {
        SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.ConfirmDelete, () => {
            let obj = {
                nRegisterID: objMasterData?.objData?.objFormData?.nRegisterID,
                nFileID: fileData.nFileID
            };
            AxiosPost("UserRecruitment/onDeletdFileAdmin", obj, (res) => {
                SwAlert.Success(AlertTitle.Success, AlertMsg.SaveComplete, () => {
                    setlstFile(res || []);
                });
            }, null, null, null, () => {
                UnBlockUI();
            })
        });
    };
    return (
        <Grid item md={12}>
            <Accordion header="อัปโหลดเอกสารเพิ่มเติ่ม" isExpanded>
                <Grid container direction="row" xs={12} md={12} sx={{}} spacing={2} marginBottom={1}>
                    <Grid item md={12} xs={12}>
                        <TableUI column={ColumnData || []}
                            row={lstFile} />
                    </Grid>
                    <Grid item md={12} xs={12}>
                        <input style={{ display: "none" }} type="file" id="onAdminCameraFile" accept="image/*,application/pdf,application/vnd.ms-excel" onChange={_SendAPIFile} />
                        {objMasterData.isEditData&&<BtnAdd onClick={onUploadFile} />}
                    </Grid>
                </Grid>
            </Accordion>
        </Grid>
    )
}
export default AdminPuloadFile;